<template>
	<div>
	  	<div class="form-group">
	    	<label for="accountholder-name">Intestatario IBAN <span class="font-13 fw-500">(di chi effettua il pagamento)</span></label>
		    <input
		        id="accountholder-name"
		        v-model="form.name"
		        class="form-control"
		        :class="{'is-invalid': form.errors.has('name')}"
		        required
		    />
	  	</div>

	  	<div class="form-group">
		    <label for="accountholder-email">Email intestatario</label>
		    <input
		        required
		        type="email"
		        id="accountholder-email"
		        v-model="form.sepa_email"
		        :class="{'is-invalid': form.errors.has('sepa_email')}"
		        class="form-control"
		        required
		    />
	  	</div>

	  	<div class="form-group">
		    <!--
		        Using a label with a for attribute that matches the ID of the
		        Element container enables the Element to automatically gain focus
		        when the customer clicks on the label.
		    -->
		    <label for="iban-element">IBAN di chi effettua il pagamento</label>
		    <div ref="ibanElement"></div>
	  	</div>
	</div>
</template>

<script>
	import {Form} from '../../helpers/Form/Form'

	export default {
	  	props: ['type', 'total', 'fiscalFileEmail', 'intentPayment'],
		data() {
			return {
			  	stripe: Stripe(window.stripeKey),	  
				form: new Form({
					id: null,
					save_card: false,
					name: '',
					pay_intent: this.intentPayment,
					total: this.total || 0,
					email: this.fiscalFileEmail,
					sepa_email: null
				}),			  	
			}
		},	
		mounted() {
		    this.$bus.$on('reset-form-data', () => {
		      	this.cardElements.forEach(el => {
		       		el.clear()
		      	})
		      	this.form.name = ''
		      	this.form.sepa_email = ''
		    })
		    
			this.init()
		},
		updated() {
			this.form.email = this.fiscalFileEmail
		},		
		methods: {
			init() {
		        let style = {
		          base: {
		            color: '#4A4A4AE6',
		            fontFamily: '"Montserrat", sans-serif',
		            fontSmoothing: 'antialiased',
		            fontSize: '16px',
		            '::placeholder': {
		              color: '#aab7c4'
		            },
		            ':focus': {
		              borderColor: '#17BEBB !important'
		            },
		          },
		          invalid: {
		            color: '#fa755a',
		            iconColor: '#fa755a'
		          }
		        };

		        let elements = this.stripe.elements({
		          	fonts: [
			            {
			              	cssSrc: 'https://fonts.googleapis.com/css?family=Montserrat:300,300i,400,400i,500,500i,600,600i,700,700i,800,800i',
			            },
		          	],
		        });

		        let options = {
		          	style: style,
		          	supportedCountries: ['SEPA'],
		          	// Elements can use a placeholder as an example IBAN that reflects
		          	// the IBAN format of your customer's country. If you know your
		          	// customer's country, we recommend that you pass it to the Element as the
		          	// placeholderCountry.
		          	placeholderCountry: 'IT',
		        };
		        var iban = elements.create('iban', options);
		        iban.mount(this.$refs.ibanElement, {style: style});

		        let inputs = document.querySelectorAll('.input');
		        inputs.forEach(function (input) {
		          input.addEventListener('focus', function () {
		            input.classList.add('focused');
		          });
		          input.addEventListener('blur', function () {
		            input.classList.remove('focused');
		          });
		          input.addEventListener('keyup', function () {
		            if (!_.isEmpty(input.value) && input.value.length === 0) {
		              input.classList.add('empty');
		            } else {
		              input.classList.remove('empty');
		            }
		          });
		        });

        		this.cardElements = [iban];		
			},
	    	async onSubmit() {
	    		this.form.errors.clear()

	      		return new Promise(async (resolve, reject) => {
	      			await this.form
	      				.submit('post', route('validate.sepa_debit'))
	      				.then(async response => {
			         		const {paymentMethod, error} = await this.stripe.createPaymentMethod({
			         			type: 'sepa_debit',
			         			sepa_debit: this.cardElements[0],
			         			billing_details: {
			         				name: this.form.name,
			         				email: this.form.sepa_email,
			         			}
			         		})

			         		if (!error) {
								resolve({
									token: paymentMethod,
									cardElements: this.cardElements,
									stripe: this.stripe,
									save_card: false,
								})	         			
			         		} else {
			         			reject(error.message)
			         		}
	      				})
	      				.catch(error => {
	      					reject(error)
	      				})
	          	})
	        },
			resetErrors() {
			  	this.stripeErrors.forEach(e => {
			   		e.message = null
			  	})
			},		    	        
	    }
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/cart/SepaDebitForm.vue